import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { QueryRef } from 'apollo-angular';
import { SearchBuyGQL, SearchBuyProductGQL } from 'graphql/buy/buy.definition';
import { GetEmployeeByReGQL } from 'graphql/employee/employee.definition';
import { GetWalletByEmployeeIdGQL } from 'graphql/wallet/wallet.definition';
import { BaseComponent } from 'src/app/base/base.component';
import {
  Buy,
  GetAllBuyQuery,
  SearchBuyProductInput,
  SearchBuyProductQuery,
} from 'src/app/model/buy';
import { GetEmployeeByReQuery } from 'src/app/model/employee';
import { GetWalletByEmployeeIdQuery } from 'src/app/model/wallet';
import { UserService } from 'src/app/service/user.service';

@Component({
  selector: 'app-clic-extracts',
  templateUrl: './clic-extracts.component.html',
  styleUrls: ['./clic-extracts.component.scss'],
})
export class ClicExtractsComponent extends BaseComponent implements OnInit {
  tableIdVisible: boolean = true;
  isModalVisible: boolean = false;
  modelBuys: Buy = new Buy();
  searchBuyProductInput: SearchBuyProductInput = new SearchBuyProductInput();
  getEmployeeByReQuery: QueryRef<GetEmployeeByReQuery>;
  getWalletByEmployeeIdQuery: QueryRef<GetWalletByEmployeeIdQuery>;
  allBuyQuery: QueryRef<GetAllBuyQuery>;
  searchBuyQuery: QueryRef<SearchBuyProductQuery>;
  buys: Buy[] = [];
  points: number;
  re: string;

  constructor(
    public router: Router,
    public route2: ActivatedRoute,
    public translate: TranslateService,
    public userService: UserService,
    public searchBuyGQL: SearchBuyGQL,
    public searchBuyProductGQL: SearchBuyProductGQL,
    private getEmployeeByReGQL: GetEmployeeByReGQL,
    private getWalletByEmployeeIdGQL: GetWalletByEmployeeIdGQL,
  ) {
    super(router, translate)
  }

  ngOnInit(): void {
    this.getUserData()
    this.getUrlParams()
  }

  getUserData() {
    this.userService.user.subscribe({
      next: data => {
        this.searchBuyProductInput.id = data.id;
        this.points = data.points ? data.points : 0 
        
        setTimeout(() => {
          this.searchBuy()
        }, 1000)
      }, error: err => super.onError(err)
    });
  }

  getUrlParams() {
    this.route2.params.subscribe(url => {
      if (!this.isNullOrUndefined(url)) {
       this.re = url.re
       this.getEmployeeByRe()
      }
    });
  }

  getEmployeeByRe() {
    this.getEmployeeByReQuery = this.getEmployeeByReGQL.watch({re: this.re});

    this.getEmployeeByReQuery.valueChanges.subscribe({
      next: ({data}) => {
        this.getWallet(data.getEmployeeRe?.id)
      },
      error: () => {
        this.points = null
        this.showMessage(this.translate.instant('attention'), this.translate.instant('ReError'), 'warning');
      }
    });
  }

  getWallet(id: string) {
    this.getWalletByEmployeeIdQuery = this.getWalletByEmployeeIdGQL.watch({employeeId: id})
    this.getWalletByEmployeeIdQuery.valueChanges.subscribe({
      next: ({data}) => {
        this.points = data?.getWalletByEmployeeId?.value
      }, 
      error: () => {
        this.points = null
        this.showMessage(this.translate.instant('attention'), this.translate.instant('WalletError'), 'warning');
      }
    })
  }


  searchBuy() {
    console.log(this.searchBuyProductInput)
    this.searchBuyQuery = this.searchBuyProductGQL.watch({
      input: this.searchBuyProductInput,
    });
    this.searchBuyQuery.valueChanges.subscribe({
      next: ({ data }) => {
        this.buys = data.searchBuyProduct as Buy[];
      },
      error: (error) => {
        this.onError(error);
      },
    });
  }

  onSearch() {
    this.searchBuy();
  }

  onChangeTableVisibility() {
    this.tableIdVisible = !this.tableIdVisible;
  }

  onOpenModal(item: Buy) {
    this.modelBuys = Object.assign({}, item);
    this.isModalVisible = true;
  }

  onCloseModal() {
    this.isModalVisible = false;
  }

  onCancelBuy() {
    this.onCloseModal();
  }

  changeName(name: string) {
    switch (name) {
      case 'Pending':
        return 'Pendente';
      case 'Delivered':
        return 'Entregue';
      case 'Canceled':
        return 'Cancelado';
      default:
        break;
    }
  }
}
